import {
  DEFAULT_MODE,
  FRAGMENT_ATOM_MODE,
  FRAGMENT_BOND_MODE,
  MOVE_MODE,
  ROTATE_MODE,
  SELECT_MODE,
  REMOVE_MODE,
  INCREASE_ATOM_CHARGE_MODE,
  DECREASE_ATOM_CHARGE_MODE,
  TOGGLE_BOND_DASHED_MODE,
  TOGGLE_BOND_WEDGED_MODE,
} from '../../../../etc/constants';

import * as _defaultMode from './default';
import * as _selectionMode from './selection';
import * as _rotationMode from './rotation';
import * as _moveMode from './move';
import * as _fragmentAtomMode from './fragmentAtom';
import * as _fragmentBondMode from './fragmentBond';
import * as _removeMode from './remove';
import _changeAtomChargeMode from './changeAtomCharge';
import _changeBondChiralityMode from './changeBondChirality';

export const defaultMode = _defaultMode;
export const selectionMode = _selectionMode;
export const rotationMode = _rotationMode;
export const moveMode = _moveMode;
export const fragmentAtomMode = _fragmentAtomMode;
export const fragmentBondMode = _fragmentBondMode;
export const removeMode = _removeMode;
export const increaseAtomChargeMode = _changeAtomChargeMode(INCREASE_ATOM_CHARGE_MODE);
export const decreaseAtomChargeMode = _changeAtomChargeMode(DECREASE_ATOM_CHARGE_MODE);
export const toggleBondDashedMode = _changeBondChiralityMode(TOGGLE_BOND_DASHED_MODE);
export const toggleBondWedgedMode = _changeBondChiralityMode(TOGGLE_BOND_WEDGED_MODE);

export const mappedTraits = {
  [DEFAULT_MODE]: defaultMode.trait,
  [SELECT_MODE]: selectionMode.trait,
  [ROTATE_MODE]: rotationMode.trait,
  [MOVE_MODE]: moveMode.trait,
  [FRAGMENT_ATOM_MODE]: fragmentAtomMode.trait,
  [FRAGMENT_BOND_MODE]: fragmentBondMode.trait,
  [REMOVE_MODE]: removeMode.trait,
  [INCREASE_ATOM_CHARGE_MODE]: increaseAtomChargeMode.trait,
  [DECREASE_ATOM_CHARGE_MODE]: decreaseAtomChargeMode.trait,
  [TOGGLE_BOND_DASHED_MODE]: toggleBondDashedMode.trait,
  [TOGGLE_BOND_WEDGED_MODE]: toggleBondWedgedMode.trait,
};
